import React from 'react';
import { render } from 'react-dom';
import { CacheProvider } from '@emotion/core';
import * as analytics from '@assets/analytics';
import Polyfilled from '@assets/polyfills';
import { customEvent, EventType } from '@assets/utils/customEvent';
import fwnPerformance from '@assets/utils/fwnPerformance';
import { KEY_RENDER_STARTED } from '@assets/utils/fwnPerformance/constants';
import { getSentryHub, logError } from '@core/logging';
import EmbedFeed from '@embed/EmbedFeed';
import { getPageUrl, uuidv4 } from '@embed/helpers';
import ErrorBoundary from './components/common/ErrorBoundary';
const embedFeedRender = (widgetParams, emotionCache) => {
    const { app_id, placement, target } = widgetParams;
    const widget_id = uuidv4();
    const inIframe = window !== window.top;
    fwnPerformance({ app_id, widget_id }).measure(KEY_RENDER_STARTED);
    const defaults = {
        onload: () => undefined,
        onclick: () => undefined,
        onerror: () => undefined,
        in_iframe: inIframe,
        location: window.location,
        language: window.navigator && window.navigator.language,
        page_url: getPageUrl(widgetParams, inIframe),
        referrer: document.referrer,
        target: document.getElementById('fwn_videos'),
    };
    const targetElement = target || defaults.target;
    Polyfilled.render(window, document, () => {
        const currentHub = getSentryHub();
        currentHub.configureScope((scope) => {
            scope.setTag('fwn_app_id', app_id !== null && app_id !== void 0 ? app_id : '');
            scope.setTag('fwn_widget_id', widget_id);
            scope.setTag('fwn_placement', placement !== null && placement !== void 0 ? placement : '');
            scope.setTag('fwn_context', 'embed_grid');
        });
        const initialParams = Object.assign(Object.assign({}, defaults), { widget_id });
        try {
            if (targetElement) {
                customEvent({
                    type: EventType.FW_EMBEDFEED_RENDER,
                    data: {
                        widget_id,
                        app_id,
                    },
                    target: targetElement,
                });
                render(<ErrorBoundary onError={(error) => logError(error)}>
            <CacheProvider value={emotionCache}>
              <EmbedFeed initialParams={initialParams} widgetParams={widgetParams}/>
            </CacheProvider>
          </ErrorBoundary>, targetElement);
            }
            else {
                logError(new Error('Missing target element'));
            }
        }
        catch (error) {
            logError(error);
        }
        analytics.comScore(window);
        analytics.protectMedia(window)(widgetParams);
    });
};
export default embedFeedRender;
